import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface NointernetMessageEvent{
  show: boolean;
  cooldown?: boolean;
  isLocalMode: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PlatformModeStateService {
  isNative$ = new BehaviorSubject<boolean>(false);
  isIos$ = new BehaviorSubject<boolean>(false);
  isAndroid$ = new BehaviorSubject<boolean>(false);
  isOnline$ = new BehaviorSubject<boolean>(true);
  isLocalMode$ = new BehaviorSubject<boolean>(false);
  isLocalModeEnabled$ = new BehaviorSubject<boolean>(false);
  canUploadFaults$ = new BehaviorSubject<boolean>(false);
  canDownloadAttachments$ = new BehaviorSubject<boolean>(false);
  showNoInternetMessage$ = new BehaviorSubject<NointernetMessageEvent>({show: false, cooldown: false, isLocalMode: false});
  clientUrl$ = new BehaviorSubject<string>('');
  currentVersion$ = new BehaviorSubject<string>('');
  useNewAttachmentDownload$ = new BehaviorSubject<boolean>(false);

  get isNative() { return this.isNative$.value; }
  get isIos() { return this.isIos$.value; }
  get isAndroid() { return this.isAndroid$.value; }
  get isOnline() { return this.isOnline$.value; }
  get isLocalMode() { return this.isLocalMode$.value; }
  get isLocalModeEnabled() { return this.isLocalModeEnabled$.value; }
  get canUploadFaults() { return this.canUploadFaults$.value; }
  get canDownloadAttachments() { return this.canDownloadAttachments$.value; }
  get showNoInternetMessage() { return this.showNoInternetMessage$.value; }
  get clientUrl() { return this.clientUrl$.value; }
  get currentVersion() { return this.currentVersion$.value; }
  get useNewAttachmentDownload() { return this.useNewAttachmentDownload$.value; }
}
